import {createApp} from 'vue';
import App from './App.vue';
import router from "@/router";
import {
    Button, Cell, ActionSheet,
    Tab, Tabs,
    Grid, GridItem,
    Image, ImagePreview, Icon, Popup,
    Collapse, CollapseItem,
    Lazyload,
    Form, Field, CellGroup, Uploader
} from 'vant';
import 'vant/lib/index.css';
import {BootstrapVue3} from 'bootstrap-vue-3';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
import i18n from "@/i18n";

const app = createApp(App);
app.use(Button);
app.use(Cell);
app.use(ActionSheet);
app.use(Tab);
app.use(Tabs);
app.use(Grid);
app.use(GridItem);
app.use(Image);
app.use(ImagePreview);
app.use(Icon);
app.use(Popup);
app.use(Collapse);
app.use(CollapseItem);
app.use(Lazyload);
app.use(Form);
app.use(Field);
app.use(CellGroup);
app.use(Uploader);
app.use(router);// 使用路由
app.use(BootstrapVue3);
app.use(i18n)
app.mount('#app')


